import CRUDField from "../core/genericCRUD/CRUDField"

const VehicleFieldsDTO: CRUDField[] = [
  {
    name: "id",
    title: "id",
    htmlType: "hidden",
    dbType: "string",
    required: false,
    groupNumber: 0,
    containerClass: "col-md-6 col-12",
  },

  {
    name: "vehiclePlate",
    title: "Placa",
    htmlType: "text",
    dbType: "string",
    required: true,
    containerClass: "col-md-6 col-12",
    groupNumber: 0,
  },

  {
    name: "insurancePolicyNumber",
    title: "No. de poliza de seguro",
    htmlType: "text",
    dbType: "string",
    required: false,
    containerClass: "col-md-6 col-12",
    groupNumber: 0,
  },

  {
    name: "driverId",
    title: "Cédula del conductor",
    htmlType: "cedula",
    dbType: "string",
    required: false,
    containerClass: "col-md-6 col-12",
    groupNumber: 0,
  },

  {
    name: "driverName",
    title: "Nombre Conductor",
    htmlType: "text",
    dbType: "string",
    required: false,
    containerClass: "col-md-6 col-12",
    groupNumber: 0,
  },

  {
    name: "driverLicense",
    title: "Licencia",
    htmlType: "text",
    dbType: "string",
    required: false,
    containerClass: "col-md-6 col-12",
    groupNumber: 0,
  },
  {
    name: "laborAccessRequestId",
    title: "laborAccessRequestId",
    htmlType: "hidden",
    dbType: "string",
  },
]

export default VehicleFieldsDTO
